import { LoanApplicationService } from "../../../services/LoanApplication";
import { notify } from "../../../shared/context/AlertContext";

interface sendLinkData {
  token: string;
  pageName: string;
  offer: any;
}

export const sendLinkHandlerFn = async (data: sendLinkData) => {
  try {
    const payload = {
      token: data.token,
      pageName: data.pageName,
      sourceEntityID: data?.offer?.sourceEntityID,
      payload: {
        mobile: data?.offer?.mobile,
        sourceEntityID: data?.offer?.sourceEntityID,
        partnerCode: data?.offer?.partner_code
      }
    };
    const response = (await LoanApplicationService.addUser(payload)) as any;
    if (response?.status) {
      notify({
        title: "Success",
        text: response?.data?.msg,
        type: "success"
      });
      const payload2 = {
        token: data?.token,
        pageName: data?.pageName,
        sourceEntityID: data?.offer?.sourceEntityID,
        payload: {
          userID: response?.data?.userID,
          program: data?.offer?.programee || null
        }
      };
      const res =
        await LoanApplicationService?.sendSessionLinkToCustomer(payload2);
      if (res?.status) {
        notify({
          title: "Success",
          type: "success",
          text: "Send Session Link to Customer"
        });
        return true;
      } else {
        notify({
          title: "Error",
          type: "error",
          text: response.error
        });
        return false;
      }
    } else {
      notify({
        title: "Error",
        text: response.error
      });
    }
  } catch (e) {
    notify({
      title: "Error",
      text: "An unexpected error occurred."
    });
  }
};
